/// <amd-module name="Artifacts/FeedSettings/containers/DetailsTabContainer" />

import { DetailsTab } from "Artifacts/FeedSettings/components/DetailsTab";
import { useDetailsTabForm } from "Artifacts/FeedSettings/hooks/DetailsTabForm";
import { FeedSettingsActions, IFeedSettingsModuleState } from "Artifacts/FeedSettings/redux";
import { IFeedSettings } from "Artifacts/FeedSettings/types";
import { ComponentState } from "Artifacts/Root/Constants";
import { isUserFeedAdmin } from "Artifacts/Root/helpers/UserHelpers";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { IRoutedTabContainerProps } from "Artifacts/Root/types/IRoutedTabContainerProps";
import * as React from "react";
import { connect } from "react-redux";

type IDetailsTabContainerProps = IRoutedTabContainerProps &
  IDetailsTabMapStateToProps &
  typeof Actions;

const Actions = {
  saveFeedSettingsAction: FeedSettingsActions.saveGeneralFeedSettings,
};

const DetailsTabContainer: React.FC<IDetailsTabContainerProps> = ({
  componentState,
  saveComponentState,
  settings,
  saveFeedSettingsAction,
}) => {
  const { feed } = useFeed();

  const {
    formState,
    resetForm,
    isFormDirty,
    onFeedDescriptionChange,
    onFeedNameChange,
    onHideDeletedPackageVersionsChange,
    onRetentionPoliciesEnabledChange,
    onRetentionPolicyCountLimitChange,
    onRetentionPolicyDaysLimitChange,
    onBadgesEnabledChange,
    onSaveSuccessful,
    errors,
  } = useDetailsTabForm(feed, settings);

  return (
    <DetailsTab
      feed={feed}
      componentState={componentState}
      saveComponentState={saveComponentState}
      settings={settings}
      isUserAdmin={feed !== undefined && isUserFeedAdmin(feed)}
      isFormDirty={isFormDirty}
      formState={formState}
      resetForm={resetForm}
      onFeedNameChange={onFeedNameChange}
      onFeedDescriptionChange={onFeedDescriptionChange}
      onHideDeletedPackageVersionsChange={onHideDeletedPackageVersionsChange}
      onBadgesEnabledChange={onBadgesEnabledChange}
      onRetentionPoliciesEnabledChange={onRetentionPoliciesEnabledChange}
      onRetentionPolicyCountLimitChange={onRetentionPolicyCountLimitChange}
      onRetentionPolicyDaysLimitChange={onRetentionPolicyDaysLimitChange}
      onSubmit={(formState) => saveFeedSettingsAction(feed, formState, onSaveSuccessful)}
      errors={errors}
    />
  );
};

interface IDetailsTabMapStateToProps {
  componentState: ComponentState;
  saveComponentState: ComponentState;
  settings?: IFeedSettings;
}

function mapStateToProps(state: IFeedSettingsModuleState): IDetailsTabMapStateToProps {
  const hubState = state["feed-settings"].hubState;
  return {
    componentState: hubState.componentState,
    saveComponentState: hubState.saveGeneralSettingsComponentState,
    settings: hubState.settings,
  };
}

const ConnectedDetailsTabContainer = connect<
  IDetailsTabMapStateToProps,
  unknown,
  IRoutedTabContainerProps
>(
  mapStateToProps,
  Actions,
)(DetailsTabContainer);

export { ConnectedDetailsTabContainer as DetailsTabContainer, IDetailsTabContainerProps };
